exports.parseQueryString = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const params = {};
  for (let [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  return params;
};

exports.validateNumber = function (phoneNumber) {
  // Validate Number length and normalize to +e164
  var phoneNumberPattern = /^\(?\+?1?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  if (phoneNumberPattern.test(phoneNumber)) {
    if (phoneNumber[0] == 1) {
      phoneNumber = "+" + phoneNumber.replace(/\D/g, "");
    } else if (phoneNumber[0] == "+") {
      phoneNumber = "+" + phoneNumber.replace(/\D/g, "");
    } else {
      phoneNumber = "+1" + phoneNumber.replace(/\D/g, "");
    }
    return phoneNumber;
  } else {
    return false;
  }
};

exports.formatPhoneNumber = function (phoneNumber) {
  // Format phone number to (xxx) xxx-xxxx
  var phoneNumberPattern = /^\+?1?(\d{3})(\d{3})(\d{4})$/;
  if (phoneNumberPattern.test(phoneNumber)) {
    var formattedPhoneNumber = phoneNumber.replace(
      phoneNumberPattern,
      "($1) $2-$3"
    );
    return formattedPhoneNumber;
  } else {
    return false;
  }
};

const getVehicleId = (vehicle) => {
  if (
    vehicle &&
    Array.isArray(vehicle.crossRef) &&
    vehicle.crossRef.length > 0
  ) {
    return vehicle.crossRef[0]?.crossRef;
  }
  return null;
};

exports.captureBooking = async function (appointment) {
  const captureUrl = `${process.env.REACT_APP_API_URL}/bookings/capture`;

  const capturePayload = {
    domain: appointment?.domain,
    siteId: appointment?.shopData?.shopId,
    fname: appointment?.customer?.fname,
    lname: appointment?.customer?.lname,
    number: appointment?.customer?.phone,
    email: appointment?.customer?.email,
    apptType: appointment?.apptType,
    duration: appointment?.service?.hours,
    title: appointment?.service?.name,
    bailOutStage: appointment?.bailOutStage,
    comments: appointment?.comments,
    date: appointment.date,
    time: appointment.time,
    service: appointment.service,
    newAppointmentId: appointment.bookingId,
    bailed: appointment.bailed,
  };

  try {
    // First fetch call for capture
    const captureResponse = await fetch(captureUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(capturePayload),
    });

    if (!captureResponse.ok) {
      throw new Error(
        "Network response was not ok " + captureResponse.statusText
      );
    }

    const captureData = await captureResponse.json();
    return captureData;
  } catch (error) {
    console.error("Error posting booking config:", error);
  }
};

// exports.postBookingConfig = async function (appointment) {
//   const bookingUrl = `${process.env.REACT_APP_API_URL}/bookings/book?domain=${appointment.domain}&shopId=${appointment.shopData?.shopId}`;

//   let rawMessage =
//     appointment?.shopData?.messages?.confirmationMessage ||
//     "Your appointment has been successfully booked! We look forward to seeing you soon.";
//   let message = rawMessage.replace(/{{new_line}}/g, "<br />");

//   if (appointment?.service) {
//     message = message.replace(
//       /{{your_service}}/g,
//       "your " + appointment?.service + " service"
//     );
//   } else {
//     message = message.replace(/{{your_service}}/g, "");
//   }

//   if (appointment?.date) {
//     message = message.replace(/{{on_date}}/g, " on " + appointment?.date);
//   } else {
//     message = message.replace(/{{on_date}}/g, "");
//   }

//   if (appointment?.time) {
//     message = message.replace(/{{at_time}}/g, " at " + appointment?.time);
//   } else {
//     message = message.replace(/{{at_time}}/g, "");
//   }

//   message = message.replace(/\s+\?/g, "?");

//   try {
//     const bookingPayload = {
//       apptType: appointment.apptType,
//       fname: appointment.customer?.fname,
//       lname: appointment.customer?.lname,
//       email: appointment.customer?.email,
//       number: appointment.customer?.phone,
//       phoneNumber: appointment.customer?.phone,

//       address1: appointment.customer?.address?.street,
//       city: appointment.customer?.address?.city,
//       state: appointment.customer?.address?.state,
//       zip: appointment.customer?.address?.zip,

//       date: appointment.date,
//       time: appointment.time,

//       year: appointment.vehicle?.year,
//       make: appointment.vehicle?.make,
//       model: appointment.vehicle?.model,
//       vehicleId: getVehicleId(appointment.vehicle),

//       integrationId: appointment.customerId,
//       dcId: appointment.dcId,
//       service: appointment.service,
//       hours: appointment.serviceHours,
//       comments: appointment.comments,
//       serviceComments: "",
//       optIn: true,
//       siteId: appointment.shopData?.shopId,

//       deferredServices: appointment?.deferredServices,

//       newAppointmentId: appointment.bookingId,
//       rwg_token: appointment.rwg_token,

//       confirmationMessage: message,
//       services: appointment?.services,
//     };

//     const bookingResponse = await fetch(bookingUrl, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(bookingPayload),
//     });

//     if (!bookingResponse.ok) {
//       throw new Error(
//         "Network response was not ok " + bookingResponse.statusText
//       );
//     }

//     await bookingResponse.json();
//   } catch (error) {
//     console.error("Error posting booking config:", error);
//   }
// };

exports.customerLookup = async function (customer, config) {
  const url = `${process.env.REACT_APP_API_URL}/bookings/customerLookup?domain=${config.domain}&shopId=${config.shopId}&number=${customer}`;

  try {
    const response = await fetch(url);
    return response.json();
  } catch (error) {
    console.error("Error fetching customer data", error);
  }
};

exports.serviceLookup = async function (customer, config) {
  const url = `${process.env.REACT_APP_API_URL}/bookings/serviceLookup?domain=${config.domain}&shopId=${config.shopId}&cid=${customer._id}&vid=${customer.vehicle_id}`;

  try {
    const response = await fetch(url);
    return response.json();
  } catch (error) {
    console.error("Error fetching customer data", error);
  }
};

exports.getBookingTimes = async function (config, date, apptType, appointment) {
  const url = `${process.env.REACT_APP_API_URL}/bookings/apptOptions?domain=${config.domain}&shopId=${config.shopId}&date=${date}&apptType=${apptType}&hours=${appointment.service?.hours}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    } else {
      return response.json();
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

exports.scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

exports.sendToWindowDataLayer = (event, service) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    clickText: service,
  });
};
